/* unplugin-vue-components disabled */import { render } from "./BaseInput.vue?vue&type=template&id=904f5090"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=904f5090&lang=scss"
script.render = render

export default script